import React from 'react';
import { CTAButton } from './CTAButton';
import { Shield, CheckCircle2 } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/3qcv3qHczgxVwHWZbSCfHM/ChatGPT-Image-26-jun-2026_-08_57_38-p.m..webp';
export function Hero() {
  return <section className="pt-10 pb-8 px-4 sm:px-6 bg-brand-paper text-center border-b-4 border-brand-gold" data-id="element-97" data-mp="9ip7ey33opts">
      <div className="relative z-10" data-id="element-98" data-mp="4jvw9cbadaws">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-navy/10 border border-brand-navy/30 text-brand-navy font-bold text-xs sm:text-sm mb-6 shadow-sm" data-id="element-99" data-mp="129qvxpsonxpz">
          <CheckCircle2 className="w-4 h-4 text-brand-gold" data-id="element-100" data-mp="sartioyigybf" />
          <span className="tracking-wide uppercase" data-id="element-101" data-mp="sddz4j1ud3r0">
            THE COMPLETE CLINICAL RESOURCE SYSTEM FOR PHYSICAL THERAPISTS
          </span>
        </div>

        <h1 className="sm:text-4xl md:text-5xl lg:text-6xl font-heading text-brand-navy mb-5 uppercase text-[20px] font-[900]" data-id="element-102" data-mp="3d2le7pgobt71">
          Stop Reinventing{' '}
          <span className="text-brand-gold" data-id="element-103" data-mp="3j8sdfvbir9n7">Your Clinical Work.</span>
        </h1>

        <p className="sm:text-lg text-brand-ink/80 font-medium mb-3 max-w-2xl mx-auto text-[14px]" data-id="element-104" data-mp="3j6odfogqqus7">
          Everything you need to assess, prescribe, plan, educate, and
          document—in one complete professional system.
        </p>
        <p className="sm:text-base text-brand-muted mb-8 max-w-2xl mx-auto text-[13px]" data-id="element-105" data-mp="3e8ms0wvuejdk">
          Save hours every week, stay organized, and focus more of your time on
          patient care instead of rebuilding the same clinical resources from
          scratch.
        </p>

        <a href="#pricing" className="block cursor-pointer mb-8" data-id="element-106" data-mp="2qk3muq83ampp">
          <img src={PRODUCT_IMG} alt="Physio Ready Box Set" className="w-full max-w-2xl mx-auto object-contain drop-shadow-2xl hover:scale-[1.02] transition-transform duration-300" data-id="element-107" data-mp="2qhqudj4pgtye" />
        </a>

        <div className="mb-6 max-w-md mx-auto" data-id="element-108" data-mp="2lla4okhuy7j7">
          <CTAButton data-id="element-109" data-mp="2ljz1alsbr1sm">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>
        </div>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-8 text-xs sm:text-sm text-brand-navy font-bold" data-id="element-110" data-mp="s2te9nr9cdqs">
          <div className="flex items-center gap-1.5" data-id="element-111" data-mp="n9i53fyz3kvp">
            <Shield className="w-4 h-4 text-brand-sage" data-id="element-112" data-mp="id9ri70fbzqn" />
            <span data-id="element-113" data-mp="dd5ews2mzp5p">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}